import React from "react";
import AnalyticsDashboard from "../component/Analytics";
import WarrList from "../warrList/warrList";

const WarrantyHome = ({
  setSelectedWarranty,
  showSidebar,
  setShowSidebar,
  createdFromBrand,
  setCreatedFromBrand,
  togglePopupShow,
  handleShowAddUser,
}) => {
  return (
    <main className="w-full h-full">
      <section>
        <AnalyticsDashboard
          showSidebar={showSidebar}
          setShowSidebar={setShowSidebar}
          setCreatedFromBrand={setCreatedFromBrand}
          togglePopupShow={togglePopupShow}
          handleShowAddUser={handleShowAddUser}
        />
        <WarrList
          setSelectedWarranty={setSelectedWarranty}
          createdFromBrand={createdFromBrand}
        />
      </section>
    </main>
  );
};

export default WarrantyHome;
